import React, { useState, useRef, useEffect } from "react";
import styles from "./Dropdown.module.css";

const Dropdown = ({
  label,
  value,
  options = [],
  onSelect,
  placeholder = "Не выбрано",
  disabled = false,
  required = false,
  hasError = false,
  error = "",
  errorMessage = ""
}) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const dropdownRef = useRef(null);

  const filteredOptions = options.filter(option =>
    option.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const selectedOption = options.find(option => option.id === value);

  const handleSelect = (item) => {
    onSelect(item.id);
    setIsOpen(false);
    setSearchTerm('');
    setIsFocused(true);
  };

  // Правильное условие для показа ошибки
  const hasErrorState = hasError || (error && error !== "");
  const showError = required && hasErrorState && !value;
  
  // Получаем текст ошибки
  const errorText = error && error !== "" ? error : errorMessage;

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
        if (!value) setIsFocused(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [value]);

  return (
    <div className={styles.dropdownContainer} ref={dropdownRef}>
      <div className={styles.inputWrapper}>
        <div
          className={`${styles.dropdownTrigger} ${!disabled ? styles.editable : ''} ${showError ? styles.errorTrigger : ''}`}
          onClick={() => !disabled && setIsOpen(!isOpen)}
          onFocus={() => !disabled && setIsFocused(true)}
          onBlur={() => !value && setIsFocused(false)}
          tabIndex={disabled ? -1 : 0}
        >
          <span className={`${styles.dropdownValue} ${showError ? styles.errorValue : ''}`}>
            {selectedOption?.name || placeholder}
          </span>
          {!disabled && (
            <span className={`${styles.dropdownIcon} ${isOpen ? styles.rotateUp : ''} ${showError ? styles.errorIcon : ''}`}>
              ▼
            </span>
          )}
        </div>
        <label
          className={`${styles.label} ${(isFocused || value) ? styles.labelFloating : ''} ${showError ? styles.labelError : ''}`}
        >
          {label}
        </label>
      </div>

      {showError && errorText && (
        <span className={styles.errorMessage}>{errorText}</span>
      )}

      {isOpen && (
        <div className={`${styles.dropdown} ${isOpen ? styles.dropdownVisible : ''}`}>
          <div className={styles.dropdownSearch}>
            <input
              type="text"
              placeholder="Поиск..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              autoFocus
            />
          </div>
          <div className={styles.dropdownList}>
            {filteredOptions.map(item => (
              <div
                key={item.id}
                className={styles.dropdownItem}
                onClick={() => handleSelect(item)}
              >
                {item.name}
              </div>
            ))}
            {filteredOptions.length === 0 && (
              <div className={styles.dropdownEmpty}>
                {options.length === 0 ? 'Нет доступных вариантов' : 'Ничего не найдено'}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Dropdown;